export const GENERAL_CONSTANTS = {
    SAVE: 'Save',
    CANCEL: 'Cancel',
    DELETE: 'Delete',
    CREATE: 'Create',
    UPDATE: 'Update',
    EDIT: 'Edit',
    ADD: 'Add',
    REMOVE: 'Remove',
    YES: 'Yes',
    REVISE: 'Revise',
    NO: 'No',
    CLOSE: 'Close',
    BACK: 'Back',
    PUBLISH: 'Publish',
    READY: 'Ready',
    DRAFT: 'Draft',
    OPTIONAL: 'Optional',
    OPTIONAL_S: 'optional',
    CANADA: 'Canada',
    USA: 'USA',
    PRODUCTS: 'Products',
    THIS: 'this',
    THESE: 'these',
    CONFIRM: 'Confirm',
    SUCCESS: 'Success',
    UNPUBLISH: 'Unpublish',
    UNSAVED_CHANGES: 'Unsaved changes',
    VIEW: 'View',
    UNSAVE_CHANGES_DESC: 'You have unsaved changes. Are you sure you want to leave this page?',
    DELETE_SELETED: 'Delete selected',
    NAME: 'Name',
    BRAND: 'Brand',
    CREATED_DATE: 'Created Date',
    ACTIONS: 'Actions',
    IMAGE: 'Image',
    VIEW_AS: 'View as',
    BUSINESS_UNIT: 'Business unit',
    VENDOR: 'Vendor',
    ALL: 'All',
    FAILED_TO_FETCH: 'Failed to fetch',
    services: 'services',
    products: 'products',
    campaigns: 'campaigns',
    ADMIN: 'Admin',
    FEATURE_DISABLE_FOR_ROLE: "This feature is disabled for your role.",
    ACCOUNT: 'Account',
    SETTINGS: 'Settings',
    LOGOUT: 'Logout',
    SELECT_VENDOR: 'Select vendor',
    SELECT_BUSINESS_UNIT: 'Select business unit',
    HIDE: 'Hide',
    REPORTS: 'Reports',
    RETURN_TO_THE_ORDER: 'Return to the order',
    UNSAVED_CHANGES_DETAILED: 'You have unsaved changes. Please save before leaving.',
    // Modal placeholders
    ENTER_FULL_NAME: 'Enter full name...',
    ENTER_EMAIL: 'Enter email address...',
    SELECT_ROLE: 'Select role',
    // Form validation messages
    VALIDATION_REQUIRED: 'Please fill in all required fields',
    VALIDATION_INVALID_EMAIL: 'Please enter a valid email address',
    // User related
    CONTACT_EMAIL: 'Contact Email',
    USER_ROLE: 'User Role',
    // View mode constants
    ALL_USERS: 'all_users',
    ADMINS: 'admins',
    // Form validation error messages
    NAME_REQUIRED: 'Name is required',
    EMAIL_REQUIRED: 'Email is required',
    INVALID_EMAIL: 'Invalid email address',
    USER_ROLE_REQUIRED: 'User role is required',
    BUSINESS_UNIT_REQUIRED: 'Business unit is required',
    // Modal titles
    CONFIRM_DELETE: 'Confirm Delete',
    // Toast messages
    INVITE_SENT_SUCCESS: 'Invite sent successfully.',
    USER_PROFILE_UPDATED: 'User profile updated successfully.',
    // Search placeholders
    SEARCH_EMAIL_USERNAME: 'Search e-mail or user name',
    // Organization UI
    BUSINESS_UNITS: 'Business Units',
    // Admin View Toggle
    ADMIN_VIEW: 'Admin view',
    
    // Brand/Logo Display
    BRAND_FALLBACK_NAME: 'Brand',
    LOGO_PLACEHOLDER_TEXT: 'Logo',
    
    // Console Messages
    UNAUTHORIZED_ADMIN_TOGGLE: 'Unauthorized admin view toggle attempt',
    GIN: 'GIN',
    ENTER_GIN: 'Enter GIN',
    BRANDS: 'Brands',
}

// Routes Viewer Role Constants
export const ROUTES_VIEWER_ROLE = {
    ADMIN: 'admin',
    EDITOR: 'editor',
} as const;


// Storage Keys Constants
export const STORAGE_KEYS = {
    // Session Storage Keys
    AUTH: 'auth',
    BRANDS: 'brands',
    COUNTRIES: 'countries',
    PRODUCT_STATUSES: 'productStatuses',
    VENDORS: 'vendors',
    COUNTRY_STATES: 'countryStates',
    SERVICE_STATUSES: 'serviceStatuses',
    SERVICE_TYPES: 'serviceTypes',
    UNIT_OF_MEASUREMENTS: 'unitOfMeasurements',
    BUSINESS_UNITS: 'businessUnits',
    ROLES: 'roles',
    PERMISSION_GROUPS: 'permissionGroups',
    FEATURE_FLAGS: 'featureFlags',
    REJECTION_REASONS: 'rejectionReasons',
    COMMISSION_STATUSES: 'commissionStatuses',
    COMMISSION_ACTIONS: 'commissionActions',

    // Session Storage - Order/Consignment Related
    PREVIEW_ROUTE_DATA: 'previewRouteData',
    SPLIT_CONSIGNMENT_BODY: 'splitConsignmentBody',

    // Local Storage Keys
    ADMIN_VIEW: 'adminView',
    SELECTED_VENDOR: 'selectedVendor',
    SELECTED_BUSINESS_UNIT: 'selectedBusinessUnit',

} as const;


export const createMaxLengthRule = (maxLength: number, errorMessage: string) => ({
    value: maxLength,
    message: errorMessage.replace('{{characters}}', maxLength.toString()),
});

export const VALIDATION_MESSAGES = {
  SELECT_VENDOR: 'Please select vendor before you try to create product.',
  SELECT_BUSINESS_UNIT: 'Please select business unit before you try to create product.',
};